<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconAuthenticated_32"
    viewBox="0 0 32 32"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M9.88 22.413q2.413 3.32 6.12 4.254 3.707-.934 6.12-4.254t2.413-7.373V8.533L16 5.333l-8.533 3.2v6.507q0 4.053 2.413 7.373m9.963-10.46a.75.75 0 1 1 1.062 1.062l-5.966 5.965a.75.75 0 0 1-1.062 0l-2.99-2.99a.75.75 0 1 1 1.062-1.063l2.46 2.46z"
        clip-rule="evenodd"
    />
</svg>
